module.exports = __webpack_public_path__ + "static/assets/567db85e8c06413f9285fb1247f274b1.png";